"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgPhone = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M33 28.92v-.025a.998.998 0 00-.85-1.014 13.845 13.845 0 01-3.032-.755.998.998 0 00-1.05.221l-1.27 1.27a1 1 0 01-1.202.162 17 17 0 01-6.375-6.375 1 1 0 01.162-1.201l1.266-1.266a1 1 0 00.224-1.057 13.817 13.817 0 01-.753-3.02 1.003 1.003 0 00-1.01-.86h-3a1 1 0 00-.996 1.074 18.8 18.8 0 002.92 8.24 18.511 18.511 0 005.7 5.697 18.774 18.774 0 008.176 2.913A1 1 0 0033 31.92v-3zm2 2.996a3 3 0 01-3.288 2.998 20.78 20.78 0 01-9.058-3.22 20.49 20.49 0 01-6.303-6.3 20.805 20.805 0 01-3.227-9.124A3 3 0 0116.11 13h2.99a3.003 3.003 0 013.001 2.59c.117.885.334 1.754.645 2.588a3.002 3.002 0 01-.679 3.17l-.717.716a15 15 0 004.586 4.586l.72-.721a3 3 0 013.164-.676c.836.312 1.705.529 2.6.647A3 3 0 0135 28.93v2.985z",
    id: "phone_svg__a"
  }));
};

var _default = SvgPhone;
exports.default = _default;